// @flow
import { connect } from 'react-redux';
import { PaymentAuthorizationResult } from './PaymentAuthorizationResult';
import { checkPaymentAuthorizationResult } from '../../modules/Payment';
import { resetToDashboard } from '../../modules/Navigation/actions';
import { paymentAuthenticationResultSelector, setPaymentAuthenticationResult } from '../../modules/Payment';

const mapStateToProps = state => ({
  paymentAuthenticationResult: paymentAuthenticationResultSelector(state),
});

const mapDispatchToProps = dispatch => ({
  checkPaymentAuthorizationResult: (stripeIntentId: string, stripeRedirectUrl: string, notificationOuid: string) =>
    dispatch(checkPaymentAuthorizationResult(stripeIntentId, stripeRedirectUrl, notificationOuid)),
  goToDashboard: () => {
    dispatch(setPaymentAuthenticationResult('PENDING'));
    resetToDashboard();
  },
  viewPayment: (stripeIntentId: string, stripeRedirectUrl: string, notificationOuid: string) => {
    dispatch(setPaymentAuthenticationResult('PENDING'));
    dispatch(checkPaymentAuthorizationResult(stripeIntentId, stripeRedirectUrl, notificationOuid));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(PaymentAuthorizationResult);
